<template>
	<div class="content homepage">
		<div class="card p-5 marineBg titulo mb-5">
			<div class="row">
				<div class="col">
					<h1>
						<span class="greenText">Our energy</span> and
						<span class="greenText">heart drive</span> a
						<span class="greenText">better tomorrow</span>
					</h1>
					<h3 class="pl-5 pr-5">
						No dia 7 de julho temos preparadas várias atividades que apelam às
						competências que caracterizam a nossa cultura EDP. Escolha em quais
						quer participar! <br />
						É fácil, basta seguir os passos em baixo.
					</h3>
				</div>
			</div>
			<div class="row passos">
				<div class="col p-5">
					<div class="row">
						<div class="col">
							<h3 class="text-center"><span>1º Passo</span></h3>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<p class="text-center">Escolha a sua Tribo!</p>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col">
							<p class="text-center">
								Cada tribo representa um tipo de atividades mais próximas da
								terra ou da água
							</p>
						</div>
					</div>
				</div>
				<div class="col p-5">
					<div class="row">
						<div class="col">
							<h3 class="text-center"><span>2º Passo</span></h3>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<p class="text-center">
								Selecione 1 atividade por categoria…
							</p>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col">
							<p class="text-center">
								<b>ENERGY</b>, para apelar ao seu lado radical <br />
								<b>DRIVE</b>, para mostrar o seu espírito explorador <br />
								<b>HEART</b>, para alcançar um estado mais zen
							</p>
						</div>
					</div>
				</div>
				<div class="col p-5">
					<div class="row">
						<div class="col">
							<h3 class="text-center"><span>3º Passo</span></h3>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<p class="text-center">
								Já está inscrito em 3 atividades. Consulte sempre que quiser a
								agenda, para se recordar das suas escolhas
							</p>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="row">
				<div class="col">
					<h3 class="text-left">
						Temos 3 Naturezas que nos diferenciam e complementam:
					</h3>
					<ul class="pl-0">
						<li><b>Pioneers</b> - Para os mais Radicais;</li>
						<li><b>Trackers</b> - Para os mais Exploradores;</li>
						<li><b>Balance</b> - Para os mais plenos.</li>
					</ul>
				</div>
				<div class="col">
					<h3 class="text-left">
						Cada uma delas é composta por diferentes actividades e tu terás de
						participar em 1 actividade de cada Natureza.
					</h3>
					<h3 class="text-left mt-3"><b>Escolhe já as tuas!</b></h3>
				</div>
			</div> -->
		</div>
		<div class="row mt-5">
			<div class="col">
				<h1 class="text-center">Escolha a sua tribo</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<div
					@click="ativo('1')"
					class="card cardGrupos grupo1 eletricGreenBg pointer"
					:class="grupo1Active ? 'ativo' : ''"
				>
					<div class="row mt-5">
						<div class="col">
							<h1>TRIBO TERRA</h1>
							<p class="descTribo text-center">
								Aqui pode fazer yoga, jogos tradicionais, tiro ao alvo,
								escalada, arborismo, paintball e trilho de 2,5 a 5 km
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div
					@click="ativo('2')"
					class="card cardGrupos grupo2 violetPurpleBg pointer"
					:class="grupo2Active ? 'ativo' : ''"
				>
					<div class="row mt-5">
						<div class="col">
							<h1>TRIBO ÁGUA</h1>
							<p class="descTribo text-white text-center">
								Aqui pode fazer treino funcional, jogos tradicionais, canoagem,
								tiro ao alvo e trilho de 1,6km a 3km (Tribo mais recomendada
								para grávidas, porque as atividades têm lugar perto
								entrada/saída do evento).
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<base-button
					@click="escolherGrupo"
					class="mb-3 bg_edp_roxo"
					size="lg"
					simple
				>
					Confirmar escolha da Tribo
					{{ grupo1Active ? "Terra" : grupo2Active ? "Água" : "" }}
				</base-button>
			</div>
		</div>
	</div>
</template>
<script>
	import api from "@/api/index";
	import swal from "sweetalert2";
	export default {
		data() {
			return {
				utilizador: [],
				grupo1Active: false,
				grupo2Active: false,
			};
		},
		methods: {
			ativo(grupo) {
				if (grupo == "1") {
					this.grupo1Active = true;
					this.grupo2Active = false;
				} else {
					this.grupo1Active = false;
					this.grupo2Active = true;
				}
			},
			async escolherGrupo() {
				var grupo = "0";
				var _this = this;
				if (this.grupo1Active) {
					grupo = "1";
				} else if (this.grupo2Active) {
					grupo = "2";
				} else {
					this.notifyVueErro("top", "right", "Tem de selecionar um grupo.");
					return;
				}

				var user_id = localStorage.getItem("active-session-niu");
				var jsonUser = {
					user_id: user_id,
				};
				let resultado = await api.buscarDados(jsonUser);
				var user = Object.values(resultado)[0];
				if (user.pontos && user.pontos.length > 4) {
					this.show = false;
					this.notifyVueErro(
						"top",
						"right",
						"Já não pode alterar o seu grupo porque já foram atribuidas presenças e/ou pontuações"
					);
					return;
				}

				var json = {
					user_id: this.utilizador.user_id,
					grupo: grupo,
				};

				if (this.utilizador.grupo == "1" && grupo == "2") {
					swal({
						title: "",
						text:
							"Já selecionou uma Tribo, se alterar o seu grupo, todas as suas vagas serão disponibilizadas e os outros utilizadores poderão preenchê-las",
						type: "warning",
						showCancelButton: true,
						confirmButtonClass: "btn btn-success btn-fill",
						confirmButtonText: "Sim",
						cancelButtonClass: "btn btn-danger btn-fill",
						cancelButtonText: "Não",
						buttonsStyling: false,
					}).then(async function(result) {
						if (result.value) {
							await api.limparVagas(json);
							var res = await api.escolherGrupo(json);
							if (res.resultado == "OK") {
								_this.inicio();
								_this.$router.push("/atividades");
								return;
							}
							return;
						}
					});
					return;
				}
				if (this.utilizador.grupo == "2" && grupo == "1") {
					swal({
						title: "",
						text:
							"Já se registou numa Tribo, se alterar o seu grupo, todas as suas vagas serão disponibilizadas e outros utilizadores poderão preenchê-las",
						type: "warning",
						showCancelButton: true,
						confirmButtonClass: "btn btn-success btn-fill",
						confirmButtonText: "Sim",
						cancelButtonClass: "btn btn-danger btn-fill",
						cancelButtonText: "Não",
						buttonsStyling: false,
					}).then(async function(result) {
						if (result.value) {
							await api.limparVagas(json);
							var res = await api.escolherGrupo(json);
							if (res.resultado == "OK") {
								_this.inicio();
								_this.$router.push("/atividades");
								return;
							}
							return;
						}
					});
					return;
				}

				var res = await api.escolherGrupo(json);
				if (res.resultado == "OK") {
					this.inicio();
					this.$router.push("/atividades");
					return;
				}
				this.inicio();
			},
			notifyVueErro(verticalAlign, horizontalAlign, texto) {
				this.$notify({
					title: texto,
					icon: "tim-icons icon-bell-55",
					horizontalAlign: horizontalAlign,
					verticalAlign: verticalAlign,
					type: "danger",
					timeout: 2000,
				});
			},
			async inicio() {
				var user_id = localStorage.getItem("active-session-niu");
				var jsonUser = {
					user_id: user_id,
				};
				let res = await api.buscarDados(jsonUser);
				if (Object.values(res).length > 0) {
					this.utilizador = Object.values(res)[0];
				}
			},
		},
		async mounted() {
			var user_id = localStorage.getItem("active-session-niu");
			var jsonUser = {
				user_id: user_id,
			};
			let res = await api.buscarDados(jsonUser);
			var user = Object.values(res)[0];
			if (user.nivel != "3") {
				this.$router.push("/promotor");
				return;
			}
			this.inicio();
		},
	};
</script>
<style>
	.ativo {
		background: #212e3e !important;
	}
	.ativo * {
		color: #fff !important;
	}

	.grupo1 h1 {
		color: #000;
		font-weight: bold;
	}

	.grupo2 h1 {
		color: #fff;
		font-weight: bold;
	}

	.titulo ul {
		list-style: none;
	}

	.descTribo {
		max-width: 70%;
		margin: auto;
		text-align: center;
	}

	.greenText {
		font-weight: bold;
		color: #28ff52 !important;
		letter-spacing: 2px;
		margin: 0 5px;
	}

	.passos span {
		border-bottom: 2px solid #fff;
		padding-bottom: 15px;
	}
</style>
